import getNumberedName from "../../../../../../frontend-libs/numbered-name";

export default function getNumberedNameFilter() {
    return getNumberedName
}
